<template>
  <div class="alert" :class="`alert--${type}`">
    <div class="alert__icon">
      <Icon :name="type" :size="20" :color="color" :type="iconStyle" />
    </div>
    <div class="alert__content">
      <p v-if="title" class="alert__title">{{ title }}</p>
      <p v-if="subtitle" class="alert__subtitle">{{ subtitle }}</p>
      <p v-if="typeof content === 'string'" class="alert__message">{{ content }}</p>
      <div v-else>
        <ul class="alert__messages">
          <li v-for="message in content" v-bind:key="message" class="alert__item">{{ message }}</li>
        </ul>
        <div v-if="showThanks" class="alert__thanks">
          <p class="alert__item">Comenzaremos a trabajar en tu solicitud a la brevedad.</p>
          <p class="alert__item">¡Gracias por contactar con nosotros!</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/lego/components/icons/Icon.vue';

export default {
  components: {
    Icon,
  },
  props: {
    type: {
      type: String,
      default: 'success',
    },
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    content: {
      type: [String, Array],
      default: null,
    },
    showThanks: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'transparent',
    },
    iconStyle: {
      type: String,
      default: 'solid',
    },
  },
};
</script>

<style lang="postcss" scoped>
.alert {
  @apply p-xxxs mb-sm flex gap-micro;

  &--success {
    @apply bg-feedback-success-lightest text-feedback-success-medium;
  }
  &--warning {
    @apply bg-feedback-alert-lightest text-feedback-alert-dark;
  }
  &--envelope {
    @apply bg-feedback-alert-soft text-neutral-superdark md:py-xxs;
  }
  &--error {
    @apply bg-feedback-error-lightest text-feedback-error-medium;
  }
  &--info {
    @apply bg-feedback-info-light text-feedback-info-dark;
  }

  &__title {
    @apply style-overline mb-xxs;
  }
  &__subtitle {
    @apply style-overline mb-nano;
  }
  &__message {
    @apply style-overline;
  }
  &__messages {
    @apply list-disc ml-xxxs space-y-quark;
  }
  &__item {
    @apply style-overline;
  }
  &__thanks {
    @apply mt-xxs space-y-quark;
  }
}
</style>
